var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ShippingHeaderList',{attrs:{"title":_vm.$t('cadastro-integracao-transportadora'),"total":_vm.total,"pagination":false}}),_c('el-card',[_c('ShippingHeaderSearch',{attrs:{"redirect":"shipping.integration.edit"},on:{"fetch":_vm.search}}),_c('ShippingIntegrationTable',{attrs:{"tableData":_vm.tableList},on:{"remove":_vm.remove}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }